export const getBoundingBoxHeight = (bbox) => {
  const { min, max } = bbox
  return Math.abs(min.y - max.y)
}

export const getBoundingBoxWidth = (bbox) => {
  const { min, max } = bbox
  return Math.abs(max.x - min.x)
}
